// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RequestEnvironmentSpec } from './RequestEnvironmentSpec';
import {
  RequestEnvironmentSpecFromJSON,
  RequestEnvironmentSpecFromJSONTyped,
  RequestEnvironmentSpecToJSON,
  RequestEnvironmentSpecToJSONTyped,
} from './RequestEnvironmentSpec';

/**
 *
 * @export
 * @interface RequestEnvironmentConfig
 */
export interface RequestEnvironmentConfig {
  /**
   *
   * @type {RequestEnvironmentSpec}
   * @memberof RequestEnvironmentConfig
   */
  config?: RequestEnvironmentSpec;
  /**
   *
   * @type {string}
   * @memberof RequestEnvironmentConfig
   */
  description?: string;
  /**
   * Name is the name of the configuration, not the environment
   * @type {string}
   * @memberof RequestEnvironmentConfig
   */
  name?: string;
  /**
   * Optional team association for the config
   * Should ideally be gleaned from the auth context
   * @type {string}
   * @memberof RequestEnvironmentConfig
   */
  team?: string;
}

/**
 * Check if a given object implements the RequestEnvironmentConfig interface.
 */
export function instanceOfRequestEnvironmentConfig(
  value: object,
): value is RequestEnvironmentConfig {
  return true;
}

export function RequestEnvironmentConfigFromJSON(
  json: any,
): RequestEnvironmentConfig {
  return RequestEnvironmentConfigFromJSONTyped(json, false);
}

export function RequestEnvironmentConfigFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RequestEnvironmentConfig {
  if (json == null) {
    return json;
  }
  return {
    config:
      json['config'] == null
        ? undefined
        : RequestEnvironmentSpecFromJSON(json['config']),
    description: json['description'] == null ? undefined : json['description'],
    name: json['name'] == null ? undefined : json['name'],
    team: json['team'] == null ? undefined : json['team'],
  };
}

export function RequestEnvironmentConfigToJSON(
  json: any,
): RequestEnvironmentConfig {
  return RequestEnvironmentConfigToJSONTyped(json, false);
}

export function RequestEnvironmentConfigToJSONTyped(
  value?: RequestEnvironmentConfig | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    config: RequestEnvironmentSpecToJSON(value['config']),
    description: value['description'],
    name: value['name'],
    team: value['team'],
  };
}
